import { Link, useLocation } from "react-router";
import Footer from "~/components/common/Footer";
import PageContainer from "~/components/common/PageContainer";
import { cn } from "~/lib/utils";

import termsHtml from "~/data/legal-document/terms_7.html?raw";
import privacyHtml from "~/data/legal-document/privacy.html?raw";
import membershipHtml from "~/data/legal-document/membership.html?raw";
import shippingHtml from "~/data/legal-document/shipping.html?raw";
import returnHtml from "~/data/legal-document/return.html?raw";
import billingHtml from "~/data/legal-document/billing.html?raw";

const LEGAL_DOCUMENTS = [
  {
    slug: "terms-of-service",
    title: "Terms of Service",
    htmlContent: termsHtml,
  },
  {
    slug: "privacy-policy",
    title: "Privacy Policy",
    htmlContent: privacyHtml,
  },
  {
    slug: "membership-terms-of-service",
    title: "Membership Terms of Service",
    htmlContent: membershipHtml,
  },
  {
    slug: "shipping-policy",
    title: "Shipping Policy",
    htmlContent: shippingHtml,
  },
  {
    slug: "returns-policy",
    title: "Returns Policy",
    htmlContent: returnHtml,
  },
  {
    slug: "billing-terms",
    title: "Billing Terms",
    htmlContent: billingHtml,
  },
];

const DEFAULT_SLUG = "terms-of-service";

export default function LegalCenterPage() {
  const { pathname } = useLocation();
  const currentSlug = pathname.split("/").filter(Boolean).pop();
  const activeSlug = LEGAL_DOCUMENTS.find(doc => doc.slug === currentSlug)?.slug || DEFAULT_SLUG;
  const activeDoc = LEGAL_DOCUMENTS.find(doc => doc.slug === activeSlug) || LEGAL_DOCUMENTS[0];

  return (
    <PageContainer>
      <div className="container mx-auto flex-1 p-3">
        <div className="flex flex-col gap-3 md:flex-row">
          {/* Left sidebar - Document navigation */}
          <nav className="w-full shrink-0 md:w-60">
            <div className="bg-background-surface rounded-lg border p-3">
              <ul className="flex flex-col gap-0.5">
                {LEGAL_DOCUMENTS.map(doc => (
                  <li key={doc.slug}>
                    <Link
                      to={`/legal/${doc.slug}`}
                      className={cn(
                        "block rounded-md px-2 py-2 text-sm transition-colors",
                        activeSlug === doc.slug
                          ? "bg-brand-50 text-text-primary font-semibold"
                          : "text-text-secondary hover:bg-muted"
                      )}
                    >
                      {doc.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Right content - Document content */}
          <main className="min-w-0 flex-1">
            <div className="bg-background-surface rounded-lg border p-4 md:p-6">
              <div
                className="prose text-text-secondary prose-headings:text-text-primary prose-a:text-brand-700 hover:prose-a:text-brand-900 prose-strong:text-text-primary max-w-none"
                dangerouslySetInnerHTML={{ __html: activeDoc.htmlContent }}
              />
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </PageContainer>
  );
}
